import { Link } from 'react-router';

import sustainabilityDesktop from 'assets/images/productPages/d-supplements_sustainability.jpg';
import acerolaImg from 'assets/images/productPages/ingredients/acerola.png';
import grapeImg from 'assets/images/productPages/ingredients/california_wild_grape.png';
import zincImg from 'assets/images/productPages/ingredients/fermented_zinc.png';
import hibiscusImg from 'assets/images/productPages/ingredients/hibiscus.png';
import horsetailImg from 'assets/images/productPages/ingredients/horsetail.png';
import purecatalystImg from 'assets/images/productPages/ingredients/purecatalyst.png';
import saffronImg from 'assets/images/productPages/ingredients/saffron.png';
import sesameSeedImg from 'assets/images/productPages/ingredients/sesame_seed.png';
import spirulinaImg from 'assets/images/productPages/ingredients/spirulina.png';
import turmericImg from 'assets/images/productPages/ingredients/turmeric.png';
import vitaminBImg from 'assets/images/productPages/ingredients/vitamin_b6.png';
import carouselImg2 from 'assets/images/productPages/prose-custom-root-source-hair-supplements-pills.jpg';
import carouselImg3 from 'assets/images/productPages/prose-custom-root-source-hair-supplements-results.jpg';
import carouselImg1 from 'assets/images/productPages/prose-model-holding-custom-root-source-hair-supplements.jpg';

import getMediaUrl from 'utils/getMediaUrl';

export const heroModule = {
  imageCarousel: [
    {
      image: carouselImg1,
      alt: 'Prose model holding custom root source hair supplements in packaging',
    },
    {
      image: carouselImg2,
      alt: 'Prose custom root source hair supplements pills',
    },
    {
      image: carouselImg3,
      alt: 'Prose custom root source hair supplements results after using for 90 days',
    },
  ],
};

export const supplementCoreContent = {
  heroModule,
  // Override the one within content/productPages/shared
  sampleFormulasSlider: [
    {
      title: 'AGE SUPPORT + THICKENING HAIR SUPPLEMENTS FOR FABIENNE',
      ingredients: [
        {
          image: purecatalystImg,
          name: 'PureCatalyst™',
          benefit: 'Hair growth*',
        },
        {
          image: saffronImg,
          name: 'Saffron extract',
          benefit: 'Stress managemement*',
        },
        {
          image: grapeImg,
          name: 'Grape seed',
          benefit: 'Age support*',
        },
        {
          image: hibiscusImg,
          name: 'Hibiscus extract',
          benefit: 'Environmental defense*',
        },
        {
          image: horsetailImg,
          name: 'Horsetail extract',
          benefit: 'Hair thickness*',
        },
        {
          image: sesameSeedImg,
          name: 'Sesame seed extract',
          benefit: 'Hair strength*',
        },
      ],
    },
    {
      title: 'GROWTH + STRESS SUPPORT HAIR SUPPLEMENTS FOR SYLVIE',
      ingredients: [
        {
          image: purecatalystImg,
          name: 'PureCatalyst™',
          benefit: 'Hair growth*',
        },
        {
          image: zincImg,
          name: 'Zinc',
          benefit: 'Scalp health*',
        },
        {
          image: turmericImg,
          name: 'Turmeric extract',
          benefit: 'Scalp soothing*',
        },
        {
          image: horsetailImg,
          name: 'Horsetail extract',
          benefit: 'Hair thickness*',
        },
        {
          image: acerolaImg,
          name: 'Acerola extract',
          benefit: 'Hair shedding control*',
        },
        {
          image: vitaminBImg,
          name: 'Vitamin B complex',
          benefit: 'Hair health*',
        },
      ],
    },
    {
      title: 'SCALP HEALTH + SHEDDING CONTROL HAIR SUPPLEMENTS FOR CHLOE',
      ingredients: [
        {
          image: purecatalystImg,
          name: 'PureCatalyst™',
          benefit: 'Hair growth*',
        },
        {
          image: horsetailImg,
          name: 'Horsetail extract',
          benefit: 'Hair thickness*',
        },
        {
          image: spirulinaImg,
          name: 'Spirulina',
          benefit: 'Scalp health*',
        },
        {
          image: zincImg,
          name: 'Zinc',
          benefit: 'Scalp health*',
        },
        {
          image: grapeImg,
          name: 'Grape seed',
          benefit: 'Age support*',
        },
        {
          image: acerolaImg,
          name: 'Acerola extract',
          benefit: 'Hair shedding control*',
        },
      ],
    },
  ],
  numbersModule: {
    title: 'Tried, tested, and shown effective',
    description:
      'In rigorous clinical testing and in-house studies, participants saw remarkable results over 90 days:',
    numbers: [
      {
        number: '93%',
        label: 'saw improved hair growth***',
      },
      {
        number: '91%',
        label: 'saw reduced hair loss**',
      },
      {
        number: '90%',
        label: 'saw reduced hair breakage***',
      },
      {
        number: '90%',
        label: 'saw improved hair appearance***',
      },
      {
        number: '83%',
        label: 'saw improved hair shine***',
      },
      {
        number: 'No',
        label: 'soy, nuts, gluten, or GMOs',
      },
    ],
    disclaimer: (
      <>
        ** Double blind clinical study vs. placebo related to our proprietary blend performed on 60
        subjects during 12 weeks.{' '}
        <a href={getMediaUrl('supplements_clinical_study.pdf')} rel="noreferrer" target="_blank">
          <strong>See full clinical study</strong>
        </a>
        <br />
        <br />
        *** Results of a 3-month in-house study of Prose 2-step hair growth program performed on 69
        subjects. <em>Results may vary</em>.{' '}
        <a href={getMediaUrl('supplements_inhouse_study.pdf')} rel="noreferrer" target="_blank">
          <strong>See full in-house study</strong>
        </a>
        ,
      </>
    ),
  },
  faqModule: {
    header: 'Frequently asked questions',
    preSupplementsRefillPouchesQuestions: [
      {
        question: (
          <>
            Why are there two separate <b>Root Source</b>
            <sup>®</sup> capsules? Do I have to take both?
          </>
        ),
        rawQuestion: 'Why are there two separate Root Source® capsules? Do I have to take both?',
        answer: (
          <>
            <b>Root Source</b>
            <sup>®</sup> is a two-capsule system designed to work holistically to deliver hair
            renewal & growth at the source. Capsule 1 lays the foundation with a customized blend of
            actives known to balance the scalp*. Capsule 2, containing our proprietary
            PureCatalyst™ complex, stimulates the hair bulb for faster hair growth and decreased
            shedding*.
            <br />
            <br />
            To ensure the best results, <b>Root Source</b>
            <sup>®</sup> is only available for purchase as a two-capsule system.
          </>
        ),
      },
      {
        question: (
          <>
            How should I take my <b>Root Source</b>
            <sup>®</sup> supplements?
          </>
        ),
        rawQuestion: 'How should I take my Root Source® supplements?',
        answer: (
          <>
            Take your two <b>Root Source</b>
            <sup>®</sup> capsules once a day, with food if you have a sensitive stomach.
            Consistency is key, so aim to take daily without skipping any doses.
          </>
        ),
      },
      {
        question: (
          <>
            My <b>Root Source</b>
            <sup>®</sup> capsules look a bit cloudy—is this normal?
          </>
        ),
        rawQuestion: 'My Root Source® capsules look a bit cloudy—is this normal?',
        answer: (
          <>
            Totally normal—<b>Root Source</b>
            <sup>®</sup> is made without any synthetic fillers or dyes, so what you’re seeing is
            natural. The actives may separate into their crystalline forms, making spots of the
            capsule appear cloudy, but this has no impact on the formulas’ freshness or potency.
          </>
        ),
      },
      {
        question: 'When can I expect to see results?',
        answer: (
          <>
            Within a few weeks of use, your scalp should feel more balanced and hair should start
            feeling softer and stronger. After three months of use, you may notice new baby hairs
            forming; stay committed, and after six months you’ll continue to see the results of new
            hair growth*. <em>Results may vary</em>.
            <br />
            <br />
            If for any reason you’re not completely satisfied with the results of your{' '}
            <b>Root Source</b>
            <sup>®</sup> supplements, you can <a href="https://prose.com/faq">contact The Pros</a>.
          </>
        ),
      },
      {
        question: (
          <>
            Will <b>Root Source</b>
            <sup>®</sup> supplements meet my Prose ingredient preferences? What if I have an
            ingredient concern?
          </>
        ),
        rawQuestion:
          'Will Root Source® supplements meet my Prose ingredient preferences? What if I have an ingredient concern?',
        answer: (
          <>
            All <b>Root Source</b>
            <sup>®</sup> supplements are vegan, cruelty-free, and gluten-free through the use of
            gluten-free wheat extract. In addition, they are free of the following: soy, nuts, GMOs,
            hormone disruptors, synthetic fillers, artificial flavors, and artificial coloring.
            <br />
            <br />
            You can view a full list of your <b>Root Source</b>
            <sup>®</sup> ingredients in your shopping cart before checkout, but please note that we
            cannot add or remove ingredients from your formulas. If pregnant, nursing, having a
            health condition or taking medication, please consult with your doctor before taking{' '}
            <b>Root Source</b>
            <sup>®</sup>.
          </>
        ),
      },
      {
        question: (
          <>
            Can I place a one-time order for <b>Root Source</b>
            <sup>®</sup>? Do I have to subscribe to this product?
          </>
        ),
        rawQuestion:
          'Can I place a one-time order for Root Source®? Do I have to subscribe to this product?',
        answer: (
          <>
            The choice is yours—you can place one-time orders for a 30-day supply of{' '}
            <b>Root Source</b>
            <sup>®</sup>, or you can subscribe at a monthly cadence. By subscribing to{' '}
            <b>Root Source</b>
            <sup>®</sup>, you’ll enjoy 15% off each refill along with all of our exclusive
            membership perks.
            <br />
            <br />
            If you’re an existing Salon member, you can add <b>Root Source</b>
            <sup>®</sup> to your next refill through your subscription page.
          </>
        ),
      },
    ],
    questions: [
      {
        question: (
          <>
            Why are there two separate <b>Root Source</b>
            <sup>®</sup> capsules? Do I have to take both?
          </>
        ),
        rawQuestion: 'Why are there two separate Root Source® capsules? Do I have to take both?',
        answer: (
          <>
            <b>Root Source</b>
            <sup>®</sup> is a two-capsule system designed to work holistically to deliver hair
            renewal & growth at the source. Capsule 1 lays the foundation with a customized blend of
            actives known to balance the scalp*. Capsule 2, containing our proprietary
            PureCatalyst™ complex, stimulates the hair bulb for faster hair growth and decreased
            shedding*.
            <br />
            <br />
            To ensure the best results, <b>Root Source</b>
            <sup>®</sup> is only available for purchase as a two-capsule system.
          </>
        ),
      },
      {
        question: (
          <>
            How should I take my <b>Root Source</b>
            <sup>®</sup> hair supplements?
          </>
        ),
        rawQuestion: 'How should I take my Root Source® hair supplements?',
        answer: (
          <>
            Take your two <b>Root Source</b>
            <sup>®</sup> capsules once a day. Take with food if you have a sensitive stomach.
            Consistency is key, so aim to take daily without skipping any doses.
          </>
        ),
      },
      {
        question: 'Do hair growth supplements work?',
        rawQuestion: 'Do hair growth supplements work?',
        answer: (
          <>
            While many of our customers see results within 90 days of consistent use, individual
            results with <b>Root Source</b>
            <sup>®</sup> may vary. To learn more about our clinical study and in-house testing with{' '}
            <b>Root Source</b>
            <sup>®</sup>, click <Link to="/pages/supplements#clinical">here</Link>.
          </>
        ),
      },
      {
        question: (
          <>
            My <b>Root Source</b>
            <sup>®</sup> capsules look a bit cloudy—is this normal?
          </>
        ),
        rawQuestion: 'My Root Source® capsules look a bit cloudy—is this normal?',
        answer: (
          <>
            Totally normal — <b>Root Source</b>
            <sup>®</sup> is made without any synthetic fillers or dyes, so what you’re seeing is
            natural. The active ingredients may separate into their crystalline forms, making spots
            of the capsule appear cloudy. This has no impact on the formulas’ freshness or potency.
          </>
        ),
      },
      {
        question: 'When can I expect to see results?',
        answer: (
          <>
            Within a few weeks of use, your scalp should feel more balanced and hair should start
            feeling softer and stronger. After three months of use, you may notice new baby hairs
            forming; stay committed, and after six months you’ll continue to see the results of new
            hair growth.* <em>Results may vary</em>. If for any reason you’re not completely
            satisfied with the results of your Root Source<sup>®</sup> supplements,{' '}
            <a href="https://prose.com/faq">send us a note</a>.
          </>
        ),
      },
      {
        question: (
          <>
            Will <b>Root Source</b>
            <sup>®</sup> hair supplements meet my Prose ingredient preferences? What if I have an
            ingredient concern?
          </>
        ),
        rawQuestion:
          'Will Root Source® hair supplements meet my Prose ingredient preferences? What if I have an ingredient concern?',
        answer: (
          <>
            All <b>Root Source</b>
            <sup>®</sup> hair supplements are vegan, cruelty-free, and gluten-free through the use
            of gluten-free wheat extract. In addition, they are free of the following: soy, nuts,
            GMOs, hormone disruptors, synthetic fillers, artificial flavors, and artificial
            coloring.
            <br />
            <br />
            You can view a full list of your <b>Root Source</b>
            <sup>®</sup> ingredients in your shopping cart before checkout, but please note that we
            cannot add or remove ingredients from your formulas. If you’re pregnant, nursing,
            dealing with a health condition or taking medication, please consult with your doctor
            before taking <b>Root Source</b>
            <sup>®</sup>.
          </>
        ),
      },
      {
        question: (
          <>
            What are <b>Root Source</b>
            <sup>®</sup> refill pouches, and why should I hold onto my first set of jars?
          </>
        ),
        rawQuestion:
          'What are Root Source® refill pouches, and why should I hold onto my first set of jars?',
        answer: (
          <>
            As a certified B-Corp, we’re deeply committed to sustainability — that’s why your first
            set of Root Source<sup>®</sup> supplements will arrive in refillable glass jars. All
            subsequent orders (whether subscription or one-off) will arrive in refill pouches. These
            pouches are 100% compostable, and allow for a significantly lower{' '}
            <a href="https://prose.com/sustainability-and-social-impact">carbon footprint</a>.
            <br />
            <br />
            Hold onto your original glass jars, and they’ll be endlessly refillable. For any
            questions, just <a href="https://prose.com/contact">send us a note</a>.
          </>
        ),
      },
    ],
  },
  sustainabilityModule: {
    description: (
      <>
        Your first order of Root Source<sup>®</sup> supplements arrives in sustainable glass
        bottles with your name on them. After that, we’ll send your custom hair supplements in
        pouches made of 100% compostable materials, so you can reuse your original bottles with
        every order.
      </>
    ),
    imageAlt:
      'Two Supplements jars within an opened box next to two refill pouches, supplements pills and a glass of water half empty',
    imageDesktop: sustainabilityDesktop,
    imageTablet: sustainabilityDesktop,
    imageMobile: sustainabilityDesktop,
    title: 'Sustainable, eco-friendly refills for less waste',
  },
  productsModule: {
    backgroundColor: 'cream',
  },
  noListModule: {
    description:
      'Our Custom Root Source® Hair Supplements are made with sustainable, traceable natural ingredients to encourage hair growth without blocking DHT or hormone disruptors. Free from unnecessary fillers and additives, they contain only the clean ingredients you need. Globally sourced, customized in the USA.',
    list: [
      'No soy, nuts, gluten',
      'GMO-free',
      'No synthetic fillers or additives',
      'No artificial flavors or colors',
      'Vegan',
      'Cruelty-free',
      '100% drug-free ingredients',
    ],
    title: 'Root Source® Hair Supplements made with high-quality, natural ingredients',
  },
};
